import Header from 'component/common/Header';
import './App.css';
import { Outlet } from 'react-router-dom';
import store from './redux/store';
import { Provider, useDispatch } from 'react-redux';
import { useEffect } from 'react';
import { findAllSubject } from './service/subjectService';
import { AppDispatch } from './redux/store/store';
import {
  setExerciseFormats,
  setFeedBackTypes,
  setGrades,
  setSchoolYears,
  setSkillTypes,
  setSubjects,
} from './redux/slice/masterDataSlice';
import { findAllGrade } from './service/gradeService';
import { findAllSchoolYear } from './service/schoolYearService';
import { findAllExerciseFormats } from './service/exerciseFormatService';
import { findAllSkillType } from './service/skillTypeService';
import AppLoading from 'component/common/AppLoading';
import viVN from 'antd/locale/vi_VN';
import { ConfigProvider } from 'antd';
import { findAllFeedBackType } from 'service/feedBackService';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

function App() {
  dayjs.extend(utc);
  dayjs.extend(timezone);
  dayjs.tz.setDefault('Asia/Ho_Chi_Minh');

  return (
    <ConfigProvider locale={viVN}>
      <Provider store={store}>
        <Main />
      </Provider>
    </ConfigProvider>
  );
}

function Main() {
  const dispatch = useDispatch<AppDispatch>();

  useEffect(() => {
    findAllSubject()
      .then((subjects) => {
        dispatch(setSubjects(subjects));
      })
      .catch((error) => console.error(error));
    findAllGrade()
      .then((grades) => {
        dispatch(setGrades(grades));
      })
      .catch((error) => console.error(error));
    findAllSchoolYear()
      .then((schoolYears) => {
        dispatch(setSchoolYears(schoolYears));
      })
      .catch((error) => console.error(error));
    findAllExerciseFormats()
      .then((exerciseFormats) => {
        dispatch(setExerciseFormats(exerciseFormats));
      })
      .catch((error) => console.error(error));
    findAllSkillType()
      .then((skillType) => {
        dispatch(setSkillTypes(skillType));
      })
      .catch((error) => console.error(error));
    findAllFeedBackType().then((feedbackType) => {
      dispatch(setFeedBackTypes(feedbackType));
    });
  }, [dispatch]);

  return (
    <div className="App h-screen flex flex-col">
      <AppLoading />
      <Header></Header>
      <div className="bg-[#ebeaea] flex-1">
        <Outlet></Outlet>
      </div>
    </div>
  );
}

export default App;
